
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M13.818 5.089h-2.182v-2.91H1.455C.65 2.18 0 2.832 0 3.635v8h1.455c0 1.204.978 2.182 2.181 2.182a2.184 2.184 0 002.182-2.182h4.364c0 1.204.978 2.182 2.182 2.182a2.184 2.184 0 002.181-2.182H16V7.998l-2.182-2.91zM3.636 12.725a1.09 1.09 0 01-1.09-1.09 1.09 1.09 0 112.182 0 1.09 1.09 0 01-1.092 1.09zm8.728 0a1.09 1.09 0 01-1.091-1.09 1.09 1.09 0 112.182 0 1.09 1.09 0 01-1.091 1.09zm-.728-4.727V6.18h1.819l1.429 1.818h-3.248z","fill":"#6C6C6C"}})])])
          )
        }
      }
    